import {Component, ChangeDetectionStrategy} from "@angular/core"
import {EntityResponsiveSidebarComponent} from "@common/components/entity/entity-responsive-sidebar/entity-responsive-sidebar.component"
import {InfiniteScrollAnchorComponent} from "@common/components/data/infinite-scroll-anchor/infinite-scroll-anchor.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-sidebar-layout",
    imports: [EntityResponsiveSidebarComponent, InfiniteScrollAnchorComponent],
    templateUrl: "./sidebar-layout.component.html",
    styleUrl: "./sidebar-layout.component.scss",
})
export class SidebarLayoutComponent {}
